"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectableOption_types_1 = require("../../utilities/selectableOption/SelectableOption.types");
exports.DropdownMenuItemType = SelectableOption_types_1.SelectableOptionMenuItemType;
//# sourceMappingURL=Dropdown.types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Dropdown/Dropdown.types.js
// module id = 402
// module chunks = 0